import { type ExternalResponse, type Response } from './get-shipments';
import { type Modalities, type Modality } from './model';

function findCheapestModality(modalities: Modalities): Modality {
  return modalities.reduce((previous, current) => {
    if (previous.cost > current.cost) {
      return current;
    }

    return previous;
  }, modalities[0]);
}

export default function adapter(externalResponse: ExternalResponse) {
  const response: Response = {
    data: externalResponse.data.reduce<Response['data']>(
      (
        previous,
        {
          skuId: externalSkuId,
          modalities: externalModalities,
          pickupInStore: externalPickupInStore,
        }
      ) => {
        const skuId = externalSkuId ?? '';

        if (externalModalities.length) {
          previous[skuId] = {
            skuId,
            modalities: externalModalities,
            chepeastModality: findCheapestModality(externalModalities),
            pickupInStore: externalPickupInStore && {
              type: 'pick_up_in_store',
              ...externalPickupInStore,
            },
          };
        }

        return previous;
      },
      {}
    ),
  };

  return response;
}
